import React, { useState, useEffect } from 'react'
import {
  Button,
  Modal,
  notification,
  Input,
  Switch,
  Select,
  Space,
  Upload
} from 'antd'
import axios from 'src/API/config'
import { API } from 'src/API'
import { DollarCircleTwoTone, UploadOutlined } from '@ant-design/icons'

export const UpdateAnnonceModal = ({
  id,
  endpoint,
  modalText,
  modalTitle,
  refresh,
  reqType,
  ntftTitle,
  btnText,
  reqData
}) => {
  const [api, contextHolder] = notification.useNotification()

  const [status, setStatus] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [superDeal, setSuperDeal] = useState('')
  const [type, setType] = useState('')
  const [price, setPrice] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = async () => {
    try {
      const data = {
        status,
        title,
        description,
        super_deal: superDeal,
        type,
        price: +price
      }

      await axios[reqType](`${endpoint}/${id}`, data)

      await api.success({
        message: ntftTitle,
        description: 'Success',
        placement: 'topRight'
      })
    } catch (e) {
      await api.error({
        message: ntftTitle,
        description: 'Error',
        placement: 'topRight'
      })
    } finally {
      refresh()
    }

    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const removeImage = async (imageId) => {
    try {
      await axios.delete(
        `${API.COMMON.annoncesEndpoint}/${id}/photos/${imageId}`
      )

      await api.success({
        message: 'Remove image',
        description: 'Success',
        placement: 'topRight'
      })
    } catch (e) {
      await api.error({
        message: 'Remove image',
        description: 'Error',
        placement: 'topRight'
      })
    } finally {
      refresh()
    }
  }

  useEffect(() => {
    setStatus(reqData?.status)
    setTitle(reqData?.title)
    setDescription(reqData?.description)
    setSuperDeal(reqData?.super_deal)
    setType(reqData?.type)
    setPrice(reqData?.price)
  }, [id])

  const OPTIONS = [
    { value: 'selling', label: 'Selling' },
    { value: 'buying', label: 'Ask' }
  ]

  const onChangeImage = async (e) => {
    const reader = new FileReader(),
      files = e.target.files
    reader.onload = async function () {
      const formData = new FormData()
      formData.append('photos[0]', files[0])
      try {
        await axios.post(
          `${API.COMMON.annoncesEndpoint}/${id}/photos`,
          formData
        )

        await api.success({
          message: 'New image',
          description: 'Success',
          placement: 'topRight'
        })
      } catch (e) {
        await api.error({
          message: 'New image',
          description: 'Error',
          placement: 'topRight'
        })
      } finally {
        refresh()
      }

      e.target.value = null
    }
    reader.readAsDataURL(files[0])
  }

  return (
    <>
      {contextHolder}
      <Button type='primary' onClick={showModal}>
        {btnText}
      </Button>
      <Modal
        title={modalTitle}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={btnText}
      >
        {modalText}

        <div style={{ marginTop: 25, marginBottom: 10 }}>
          <label
            for='uploadPhoto'
            style={{
              padding: 10,
              backgroundColor: '#fff',
              border: '1px #ccc solid',
              borderRadius: 5,
              cursor: 'pointer'
            }}
          >
            Upload photo
          </label>
          <input
            accept='image/png, image/jpeg, image/jpg'
            style={{ display: 'none' }}
            id='uploadPhoto'
            type='file'
            onChange={(e) => onChangeImage(e)}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Photos:</p>
          {reqData?.photos?.data?.length
            ? reqData?.photos?.data?.map((photo) => (
                <Space wrap style={{ padding: 10 }}>
                  <img
                    alt={`Annonce photo ${photo?.id}`}
                    key={photo?.id}
                    src={photo?.thumb_s}
                  />
                  <Button onClick={() => removeImage(photo?.id)}>Remove</Button>
                </Space>
              ))
            : 'No photos'}
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Title</p>
          <Input
            placeholder='Title'
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Description</p>
          <Input.TextArea
            placeholder='Description'
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            rows={7}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Price</p>
          <Input
            placeholder='Price'
            prefix={<DollarCircleTwoTone />}
            onChange={(e) => setPrice(e.target.value)}
            value={price}
            type='number'
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Super deal</p>
          <Switch checked={superDeal} onChange={(e) => setSuperDeal(e)} />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Type</p>
          <Select
            style={{ width: 200 }}
            value={type}
            onChange={setType}
            options={OPTIONS}
          />
        </div>
      </Modal>
    </>
  )
}
